// General
import React from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './EditBlogDetails.css';

// Component
import EditBlogDetailsManagement from '../../../components/siteadmin/EditBlogDetails/EditBlogDetails';

//import NotFound from '../../notFound/NotFound';

class EditBlogDetails extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        blogId: PropTypes.number.isRequired
    };


    render() {
        const { blogId, title, initialValues } = this.props;

        return (
            <EditBlogDetailsManagement
                blogId={blogId} title={title}
            />
        );
    }
}

const mapState = (state) => ({});
  
const mapDispatch = {};

export default withStyles(s)(connect(mapState, mapDispatch)(EditBlogDetails));


// WEBPACK FOOTER //
// src/routes/siteadmin/editBlogDetails/EditBlogDetails.js